module.exports = __webpack_public_path__ + "img/step27_a_printer_basic_install_multi_sheet_tray.2db4bfae.png";